import { z } from 'zod';

var _EventType = /* @__PURE__ */ ((_EventType2) => {
  _EventType2["OPEN_APP"] = "open_app";
  _EventType2["REGISTER_NEW_AGENT"] = "register_new_agent";
  _EventType2["REGISTER_EXISTING_AGENT"] = "register_existing_agent";
  _EventType2["SWITCH_TO_SMS_LOGIN"] = "switch_to_sms_login";
  _EventType2["SWITCH_TO_EMAIL_LOGIN"] = "switch_to_email_login";
  _EventType2["RESEND_CODE"] = "resend-code";
  _EventType2["VIEW_LOGIN"] = "view_login";
  _EventType2["VIEW_LOGIN_VERIFY"] = "view_login_verify";
  _EventType2["VIEW_REGISTER"] = "view_register";
  _EventType2["LOGIN"] = "login";
  _EventType2["LOGOUT"] = "logout";
  _EventType2["REGISTER"] = "register";
  _EventType2["VIEW_AGENT_EDIT_PROFILE"] = "view_agent_edit_profile";
  _EventType2["VIEW_AGENT_LISTINGS"] = "view_agent_listings";
  _EventType2["VIEW_AGENT_SHARING"] = "view_agent_sharing";
  _EventType2["COPY_AGENT_FORM_URL"] = "copy_agent_form_url";
  _EventType2["VIEW_OFFER"] = "view_offer";
  _EventType2["CHANGE_OFFER_LIST_VIEW"] = "change_offer_list_view";
  _EventType2["VIEW_ACTIVITY_FEED"] = "view_activity_feed";
  _EventType2["VIEW_LISTING_SETTINGS"] = "view_listing_settings";
  _EventType2["VIEW_AGENT_CARD"] = "view_agent_card";
  _EventType2["INTERACT_AGENT_CARD"] = "interact_agent_card";
  _EventType2["SHARE_AGENT_CARD"] = "share_agent_card";
  _EventType2["SHARE_OFFER_FORM"] = "share_offer_form";
  return _EventType2;
})(_EventType || {});
var AppEvent;
((AppEvent2) => {
  AppEvent2.EventType = _EventType;
  const BaseSchema = z.object({
    userId: z.string().optional(),
    agentId: z.string().optional(),
    buyerId: z.string().optional(),
    adminId: z.string().optional(),
    products: z.array(z.string()).optional()
  });
  AppEvent2.OpenAppEventSchema = BaseSchema.extend({
    type: z.literal("open_app" /* OPEN_APP */)
  });
  AppEvent2.RegisterNewAgentEventSchema = BaseSchema.extend({
    type: z.literal("register_new_agent" /* REGISTER_NEW_AGENT */)
  });
  AppEvent2.RegisterExistingAgentEventSchema = BaseSchema.extend({
    type: z.literal("register_existing_agent" /* REGISTER_EXISTING_AGENT */)
  });
  AppEvent2.SwitchToSmsLoginEventSchema = BaseSchema.extend({
    type: z.literal("switch_to_sms_login" /* SWITCH_TO_SMS_LOGIN */)
  });
  AppEvent2.SwitchToEmailLoginEventSchema = BaseSchema.extend({
    type: z.literal("switch_to_email_login" /* SWITCH_TO_EMAIL_LOGIN */)
  });
  AppEvent2.ResendCodeEventSchema = BaseSchema.extend({
    type: z.literal("resend-code" /* RESEND_CODE */),
    channel: z.string()
  });
  AppEvent2.ViewLoginEventSchema = BaseSchema.extend({
    type: z.literal("view_login" /* VIEW_LOGIN */),
    channel: z.string()
  });
  AppEvent2.ViewLoginVerifyEventSchema = BaseSchema.extend({
    type: z.literal("view_login_verify" /* VIEW_LOGIN_VERIFY */),
    channel: z.string()
  });
  AppEvent2.ViewRegisterEventSchema = BaseSchema.extend({
    type: z.literal("view_register" /* VIEW_REGISTER */)
  });
  AppEvent2.LoginEventSchema = BaseSchema.extend({
    type: z.literal("login" /* LOGIN */),
    channel: z.string().optional(),
    provider: z.string().optional()
  });
  AppEvent2.LogoutEventSchema = BaseSchema.extend({
    type: z.literal("logout" /* LOGOUT */)
  });
  AppEvent2.RegisterEventSchema = BaseSchema.extend({
    type: z.literal("register" /* REGISTER */)
  });
  AppEvent2.ViewAgentEditProfileEventSchema = BaseSchema.extend({
    type: z.literal("view_agent_edit_profile" /* VIEW_AGENT_EDIT_PROFILE */)
  });
  AppEvent2.ViewAgentListingsEventSchema = BaseSchema.extend({
    type: z.literal("view_agent_listings" /* VIEW_AGENT_LISTINGS */)
  });
  AppEvent2.ViewAgentSharingEventSchema = BaseSchema.extend({
    type: z.literal("view_agent_sharing" /* VIEW_AGENT_SHARING */)
  });
  AppEvent2.CopyAgentFormUrlEventSchema = BaseSchema.extend({
    type: z.literal("copy_agent_form_url" /* COPY_AGENT_FORM_URL */),
    listingId: z.string()
  });
  AppEvent2.ChangeOfferListViewEventSchema = BaseSchema.extend({
    type: z.literal("change_offer_list_view" /* CHANGE_OFFER_LIST_VIEW */),
    action: z.string(),
    value: z.string()
  });
  AppEvent2.ViewActivityFeedEventSchema = BaseSchema.extend({
    type: z.literal("view_activity_feed" /* VIEW_ACTIVITY_FEED */)
  });
  AppEvent2.ViewOfferEventSchema = BaseSchema.extend({
    type: z.literal("view_offer" /* VIEW_OFFER */),
    offerId: z.string(),
    listingId: z.string()
  });
  AppEvent2.ViewListingSettingsSchema = BaseSchema.extend({
    type: z.literal("view_listing_settings" /* VIEW_LISTING_SETTINGS */),
    listingId: z.string()
  });
  AppEvent2.ViewAgentCardSchema = BaseSchema.extend({
    type: z.literal("view_agent_card" /* VIEW_AGENT_CARD */),
    agentId: z.string(),
    visitorId: z.string()
  });
  AppEvent2.InteractAgentCardSchema = BaseSchema.extend({
    type: z.literal("interact_agent_card" /* INTERACT_AGENT_CARD */),
    agentId: z.string(),
    visitorId: z.string(),
    interaction: z.string(),
    value: z.string().optional()
  });
  AppEvent2.ShareAgentCardSchema = BaseSchema.extend({
    type: z.literal("share_agent_card" /* SHARE_AGENT_CARD */),
    agentId: z.string()
  });
  AppEvent2.ShareOfferFormSchema = BaseSchema.extend({
    type: z.literal("share_offer_form" /* SHARE_OFFER_FORM */),
    listingId: z.string()
  });
  AppEvent2.Validators = {
    ["open_app" /* OPEN_APP */]: AppEvent2.OpenAppEventSchema,
    ["register_new_agent" /* REGISTER_NEW_AGENT */]: AppEvent2.RegisterNewAgentEventSchema,
    ["register_existing_agent" /* REGISTER_EXISTING_AGENT */]: AppEvent2.RegisterExistingAgentEventSchema,
    ["switch_to_sms_login" /* SWITCH_TO_SMS_LOGIN */]: AppEvent2.SwitchToSmsLoginEventSchema,
    ["switch_to_email_login" /* SWITCH_TO_EMAIL_LOGIN */]: AppEvent2.SwitchToEmailLoginEventSchema,
    ["resend-code" /* RESEND_CODE */]: AppEvent2.ResendCodeEventSchema,
    ["view_login" /* VIEW_LOGIN */]: AppEvent2.ViewLoginEventSchema,
    ["view_login_verify" /* VIEW_LOGIN_VERIFY */]: AppEvent2.ViewLoginVerifyEventSchema,
    ["login" /* LOGIN */]: AppEvent2.LoginEventSchema,
    ["logout" /* LOGOUT */]: AppEvent2.LogoutEventSchema,
    ["register" /* REGISTER */]: AppEvent2.RegisterEventSchema,
    ["view_register" /* VIEW_REGISTER */]: AppEvent2.ViewRegisterEventSchema,
    ["view_agent_edit_profile" /* VIEW_AGENT_EDIT_PROFILE */]: AppEvent2.ViewAgentEditProfileEventSchema,
    ["view_agent_listings" /* VIEW_AGENT_LISTINGS */]: AppEvent2.ViewAgentListingsEventSchema,
    ["view_agent_sharing" /* VIEW_AGENT_SHARING */]: AppEvent2.ViewAgentSharingEventSchema,
    ["copy_agent_form_url" /* COPY_AGENT_FORM_URL */]: AppEvent2.CopyAgentFormUrlEventSchema,
    ["change_offer_list_view" /* CHANGE_OFFER_LIST_VIEW */]: AppEvent2.ChangeOfferListViewEventSchema,
    ["view_offer" /* VIEW_OFFER */]: AppEvent2.ViewOfferEventSchema,
    ["view_activity_feed" /* VIEW_ACTIVITY_FEED */]: AppEvent2.ViewActivityFeedEventSchema,
    ["view_listing_settings" /* VIEW_LISTING_SETTINGS */]: AppEvent2.ViewListingSettingsSchema,
    ["view_agent_card" /* VIEW_AGENT_CARD */]: AppEvent2.ViewAgentCardSchema,
    ["interact_agent_card" /* INTERACT_AGENT_CARD */]: AppEvent2.InteractAgentCardSchema,
    ["share_agent_card" /* SHARE_AGENT_CARD */]: AppEvent2.ShareAgentCardSchema,
    ["share_offer_form" /* SHARE_OFFER_FORM */]: AppEvent2.ShareOfferFormSchema
  };
})(AppEvent || (AppEvent = {}));

export { AppEvent, _EventType };
